import axios from '@/user/axios.js'

const moduleTrend = {
  namespaced: true,
  state: {
    requestingStatus: {
      monthly: false,
      monthlySalesBySubCategoryName: false,
      monthlySalesBySellerCategory: false,
      adSalesByTitle: false,
      adSalesByAsin: false,
      adSalesByParentAsin: false,
      adSalesByBrand: false,
      adSalesByCategoryName: false,
      adSalesBySubCategoryName: false,
      adSalesBySellerCategory: false,
      adSalesBySellerCategory2: false,
      adSalesBySellerCategory3: false,
      adSalesBySellerCategory4: false,
      adSalesBySellerCategory5: false,
      sellerSubscription: false
    },
    reportData: {
      monthly: [],
      monthlySalesBySubCategoryName: [],
      monthlySalesBySellerCategory: [],
      adSalesByTitle: [],
      adSalesByAsin: [],
      adSalesByParentAsin: [],
      adSalesByBrand: [],
      adSalesByCategoryName: [],
      adSalesBySubCategoryName: [],
      adSalesBySellerCategory: [],
      adSalesBySellerCategory2: [],
      adSalesBySellerCategory3: [],
      adSalesBySellerCategory4: [],
      adSalesBySellerCategory5: [],
      sellerSubscription: []
    }
  },
  mutations: {
    SET_REQUESTING_STATUS (state, data) {
      state.requestingStatus = {
        ...state.requestingStatus,
        ...data
      }
    },
    SET_REPORT_DATA (state, data) {
      state.reportData = {
        ...state.reportData,
        ...data
      }
    }
  },
  actions: {
    fetchReport (context, payload) {
      return new Promise(async (resolve, reject) => {
        context.commit('SET_REQUESTING_STATUS', {
          [payload.action]: true
        })
        const sellerId = context.rootState.account.activeAccount.sellerId
        try {
          const res = await axios.get(`/api/trend/${sellerId}`, {
            params: payload
          })
          context.commit('SET_REQUESTING_STATUS', {
            [payload.action]: false
          })
          if (res.data.success) {
            context.commit('SET_REPORT_DATA', {
              [payload.action]: res.data.data
            })
          }
          resolve(res)
        } catch (err) {
          context.commit('SET_REQUESTING_STATUS', {
            [payload.action]: false
          })
          reject(err)
        }
      })
    }
  }
}

export default moduleTrend
